<template>
    <div class="customerListWrap">
        <!-- <h3>         {{lastPage}}</h3> -->
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item label="客户总数">
                        共{{customerTotal}} 位
                    </el-form-item>
                    <el-form-item>
                        <el-input  placeholder="手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="全部身份" v-model="formObj.userType" @change="multiSearchClick">
                            <el-option label="全部身份" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in userTypeOptions" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item >
                        <el-select placeholder="身份审核状态" v-model="formObj.authResult" @change="multiSearchClick">
                            <el-option label="身份全部状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in authResultOptions" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="系统使用申请状态" v-model="formObj.appState" @change="multiSearchClick">
                            <el-option label="系统使用全部状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in appStateOptions" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item>
                         <el-button type="primary" @click="downLoadExcel(3)">下载客户列表</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="公司名称">
                    <template slot-scope="scope">{{ scope.row.company_name }}</template>
                </el-table-column>
                <el-table-column label="品牌" >
                    <template slot-scope="scope">{{ scope.row.companyBrand }}</template>
                </el-table-column>
                <el-table-column label="注册手机号" >
                    <template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
                </el-table-column>
                <el-table-column label="注册时间">
                    <template slot-scope="scope">{{ scope.row.user_register_time }}</template>
                </el-table-column>
                <el-table-column label="身份">
                    <template slot-scope="scope">{{ scope.row.userType |turnValToText('user_type')}}</template>
                </el-table-column>
                <el-table-column label="身份状态">
                    <template slot-scope="scope">
                        <span :class="{red:scope.row.auth_result=='p',green:scope.row.auth_result=='y',orange_lighter:scope.row.auth_result=='n'}">
                            {{ scope.row.auth_result |turnValToText('auth_result')}}
                         </span>
                    
                    </template>
                </el-table-column>
                <el-table-column label="公司所在地">
                    <template slot-scope="scope">{{ scope.row.company_province }}{{ scope.row.company_city }}{{ scope.row.company_district }}</template>
                </el-table-column>
                <el-table-column label="系统使用状态">
                    <template slot-scope="scope">
                        <span :class="{red:scope.row.appState=='1'||scope.row.appState=='2',green:scope.row.appState=='3',orange_lighter:scope.row.appState=='0'}">
                            {{ scope.row.appState |turnValToText('app_apply_result') }}

                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)" v-if="functionViewCustomerDetail">详情</span>
                            <span class="spanBtn orange" @click="openAuth(scope.row)" v-if="scope.row.auth_result=='p'&&functionCustomerIdentityAuth">身份审核</span>
                            <span class="spanBtn orange" @click="toPlatUserAuth(scope.row)" v-if="scope.row.appId&&functionSystemApplyAuth">系统使用申请</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
        <authmodal :current="currentAuthList" :isShow="isShowModal" @close="closeModal" @submitSucess="getTableLists"></authmodal>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'
    import authmodal from '@/components/authModal.vue'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                currentAuthList:{},
                isShowModal: false, //审核的modal
                isLoading:false,
                tableData:[],
                lastPage:'',
                customerTotal:'-',
                formObj:{
                    fuzzyQuery:'',
                    userType:'',
                    authResult:'',
                    appState:'',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total:0,
            }
        },
        components: {
            authmodal
        },
        computed: {
            functionViewCustomerDetail(){
                return utils.getCurrentFunction().indexOf("viewCustomerDetail")>-1
            },
            functionCustomerIdentityAuth(){
                return utils.getCurrentFunction().indexOf("customerIdentityAuth")>-1
            },
            functionSystemApplyAuth(){
                return utils.getCurrentFunction().indexOf("systemApplyAuth")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            appStateOptions() {
                return wordData.app_apply_result
            },
            adminId(){
                return utils.getAdminId()
            }
            
        },
        methods: {
            getParams(){
              this.lastPage=this.$route.query.from  
            },
            downLoadExcel(type){
                let _this=this
                let arg={
                    adminId:_this.adminId,
                    type:type
                }
                ajaxPost('/file/exportHttp', arg).then(function(res) {
                    console.log(res)
                    if(res.errorCode==200){
                        _this.$message("下载成功")  
            
                        let url=res.data
                        window.location.href= _this.IMG_PREV+url
                        
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            openAuth(obj){
                let list = {
                    company_name: obj.company_name,
                    user_id: obj.user_Id,
                    auth_id: obj.auth_id
                }
                this.currentAuthList = list
                this.isShowModal = true
            },
            closeModal() {
                this.isShowModal = false
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    authResult: this.formObj.authResult,
                    userType: this.formObj.userType,
                    appState:this.formObj.appState,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists(){
              let _this=this
              let arg={}
              _this.isLoading=true
              ajaxPost('/admin/getUserList',_this.searchObj).then(function(res) {
                  if(res.errorCode==200){
                      _this.total=parseInt(res.data.queryTotalCount) 
                      _this.customerTotal=res.data.totalCount
                      _this.tableData=res.data.userAuthList
                  }
                  _this.isLoading=false
              }, function(res) {
                  _this.isLoading=false
              })  
            },
            toDetail(list) {
                let _this=this
                utils.setSearchObjToSession(_this.searchObj)
                let userId=list.user_Id
                this.$router.push({name: 'customerDetail',params:{ userId: userId}})
            },
            toPlatUserAuth(list) {
                let _this=this
                utils.setSearchObjToSession(_this.searchObj)
                 let appId=list.appId
                this.$router.push({name: 'platUserAuth',params: { appId: appId}})
            },
        },
        created() {
            console.log("执行created")
            this.getParams()
        	//获取session里存储的搜索条件，并赋值给当前表单
            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                _this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                _this.formObj.userType=_this.searchObj.userType
                _this.formObj.authResult=_this.searchObj.authResult
                _this.formObj.appState=_this.searchObj.appState
                // this.formObj.state=_this.searchObj.state
            }else if(_this.lastPage=='home'){
                console.log("session里没有搜索条件，但来自首页按钮跳转")
                _this.searchObj.appState="1"
                _this.formObj.appState=_this.searchObj.appState
            }else{
                console.log("session里没有搜索条件，也不是首页直接跳转")
            }
            this.getTableLists()
        
        },
        // beforeRouteEnter (to, from, next) {
        //   next(vm => {
        //       console.log()
        //       if(from.name=='home'){
        //           vm.lastPage='home'
        //           vm.searchObj.appState="1"
        //           vm.formObj.appState='1'
        //       }
        //       
        //     // 通过 `vm` 访问组件实例
        //   })
        // },
        mounted(){
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .customerListWrap {
        .el-form--inline .el-form-item{margin-right: 0px; max-width: 150px;}
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
               float: right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem;padding-top:0;
       }
    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/list.vue